import { CATALOGO } from '@/constants/catalogo';
import { fmt } from '@/lib/utils';

export default function ProductoCard({ producto }) {
  const catalogo = CATALOGO[producto.id];
  if (!catalogo) return null;
  const Icon = catalogo.icon;

  const renderDetail = () => {
    if (producto.id === 'clickXperience' && producto.config?.proyectos) {
      return (
        <div className="mt-3 space-y-2">
          {producto.config.proyectos.map((p, i) => {
            const f1 = p.fase1.reduce((s, x) => s + x.precio, 0);
            const f2 = p.fase2.reduce((s, x) => s + x.precio, 0);
            const f3 = p.fase3.reduce((s, x) => s + x.precio, 0);
            return (
              <div
                key={i}
                className="p-3 bg-black/20 rounded border border-neutral-800"
              >
                <div className="text-sm text-white font-medium mb-2">
                  {p.nombre || `Proyecto ${i + 1}`}
                </div>
                <div className="text-xs text-neutral-400 space-y-1">
                  <div className="flex justify-between">
                    <span>Fase 1: Modelado y Levantamiento 3D</span>
                    <span>{fmt(f1)}</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Fase 2: Entregables a partir de 3D</span>
                    <span>{fmt(f2)}</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Fase 3: Programación e Implementación</span>
                    <span>{fmt(f3)}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="p-5 bg-neutral-900/30 border border-neutral-800 rounded-xl">
      <div className="flex items-start gap-4">
        <div className="w-10 h-10 rounded-lg bg-brand-gold/10 flex items-center justify-center flex-shrink-0">
          <Icon className="w-5 h-5 text-brand-gold" />
        </div>
        <div className="flex-1">
          <div className="flex items-start justify-between mb-1">
            <div>
              <h4 className="text-white font-semibold">{catalogo.nombre}</h4>
              <p className="text-sm text-neutral-400 mt-1">{catalogo.descripcion}</p>
            </div>
            <div className="text-right ml-4 flex-shrink-0">
              <div className="text-white font-bold text-lg">{fmt(producto.precioFinal)}</div>
            </div>
          </div>
          {renderDetail()}
        </div>
      </div>
    </div>
  );
}
